import React from "react";
import { useParams } from "react-router-dom";

import LogoULagos from "../../assets/img/ulagos_bco-11.png";

const NavbarExternal = () => {
  const { surveyRoute } = useParams();

  return (
    <nav className="navbar-external">
      <div className="navbar-external__brand">
        <a href={surveyRoute ? "splash" : "/"}>
          <img src={LogoULagos} alt="logo-ulagos" className="navbar-external__logo" />
        </a>
      </div>
    </nav>
  );
};

export default NavbarExternal;